import { TransactionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/transaction/paginated/transaction.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { TransactionListLocationCell } from '@app/feature/transaction/transaction-list/transaction-list-location.cell';
import { TransactionListLocationHeader } from '@app/feature/transaction/transaction-list/transaction-list-location.header';

export const TokenTransactionListLocationColumn: IdentifiedColumnDef<
  TransactionModel,
  TransactionModel['location']
> = {
  enableSorting: false,
  header: TransactionListLocationHeader,
  cell: TransactionListLocationCell,
};
